import { extend } from 'flarum/common/extend';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import Button from 'flarum/common/components/Button';
import ReminderModal from './components/ReminderModal';
import { getRecitalForDiscussion, loadRecitals } from './recitalRecord';

/**
 * Option B coordinator actions on a recital's announcement/submission threads.
 *
 * Drafts are edited NATIVELY (the coordinator edits the hidden thread's first
 * post via the normal composer). This hub only adds the lifecycle actions:
 * reveal (Create Announcement / Open Submissions), reminders, and cross-links.
 */

var IN_PROGRESS = ['draft', 'announced', 'submissions_open'];
function statusOf(recital) {
  return recital && recital.status ? recital.status() : null;
}
function sameDiscussion(idA, discussion) {
  var b = discussion && discussion.id ? discussion.id() : null;
  return idA !== null && idA !== undefined && b !== null && b !== undefined && String(idA) === String(b);
}
function goToDiscussion(id) {
  m.route.set('/d/' + id);
}
function ensureRecitalsLoaded(page) {
  if (!app.forum || !app.forum.attribute('canPublishRecital')) return;
  if (page.recitalActionsLoading || page.recitalActionsLoaded) return;
  page.recitalActionsLoading = true;
  loadRecitals().then(() => {
    page.recitalActionsLoaded = true;
    page.recitalActionsLoading = false;
    m.redraw();
  }).catch(() => {
    page.recitalActionsLoading = false;
  });
}
function reveal(recital, phase) {
  app.request({
    method: 'POST',
    url: app.forum.attribute('apiUrl') + '/recitals/reveal',
    body: {
      recitalId: Number(recital.id()),
      phase: phase
    }
  }).then(() => {
    app.alerts.show({
      type: 'success'
    }, app.translator.trans('pianotell-recitals.forum.reveal_success'));
    // Reload so the now-revealed thread, bumped timestamps, and updated
    // status/actions are reflected.
    window.location.reload();
  }).catch(() => {
    app.alerts.show({
      type: 'error'
    }, app.translator.trans('pianotell-recitals.forum.reveal_error'));
  });
}
export default function addRecitalThreadActions() {
  extend(DiscussionPage.prototype, 'oninit', function () {
    ensureRecitalsLoaded(this);
  });
  extend(DiscussionPage.prototype, 'sidebarItems', function (items) {
    if (!app.forum || !app.forum.attribute('canPublishRecital')) return;
    var discussion = this.discussion;
    if (!discussion) return;
    ensureRecitalsLoaded(this);
    var recital = getRecitalForDiscussion(discussion);
    if (!recital || IN_PROGRESS.indexOf(statusOf(recital)) === -1) return;
    var status = statusOf(recital);
    var announcementId = recital.announcementDiscussionId ? recital.announcementDiscussionId() : null;
    var submissionId = recital.submissionDiscussionId ? recital.submissionDiscussionId() : null;
    var isAnnouncement = sameDiscussion(announcementId, discussion);
    var isSubmission = sameDiscussion(submissionId, discussion);
    if (!isAnnouncement && !isSubmission) return;
    if (isAnnouncement && status === 'draft') {
      items.add('recitalCreateAnnouncement', Button.component({
        icon: 'fas fa-bullhorn',
        className: 'Button Button--primary Button--recitalCreateAnnouncement Button--block',
        onclick: () => reveal(recital, 'announcement')
      }, app.translator.trans('pianotell-recitals.forum.create_announcement')), 60);
    }
    if (isSubmission && status === 'announced') {
      items.add('recitalOpenSubmissions', Button.component({
        icon: 'fas fa-door-open',
        className: 'Button Button--primary Button--recitalOpenSubmissions Button--block',
        onclick: () => reveal(recital, 'submission')
      }, app.translator.trans('pianotell-recitals.forum.open_submissions')), 60);
    }
    if (isAnnouncement && (status === 'announced' || status === 'submissions_open')) {
      items.add('recitalReminder', Button.component({
        icon: 'fas fa-bell',
        className: 'Button Button--recitalReminder Button--block',
        onclick: () => app.modal.show(ReminderModal, {
          recital,
          discussion
        })
      }, app.translator.trans('pianotell-recitals.forum.add_reminder')), 59);
    }
    if (isAnnouncement && submissionId) {
      items.add('recitalViewSubmission', Button.component({
        icon: 'fas fa-arrow-right',
        className: 'Button Button--recitalViewSubmission Button--block',
        onclick: () => goToDiscussion(submissionId)
      }, app.translator.trans('pianotell-recitals.forum.view_submission_thread')), 57);
    }
    if (isSubmission && announcementId) {
      items.add('recitalViewAnnouncement', Button.component({
        icon: 'fas fa-arrow-left',
        className: 'Button Button--recitalViewAnnouncement Button--block',
        onclick: () => goToDiscussion(announcementId)
      }, app.translator.trans('pianotell-recitals.forum.view_announcement_thread')), 57);
    }
  });
}